import { ProfileClient } from '../api/client';
import { profileClient } from '../app';
import AuthService from './auth-service';
import AuthClient from './auth-client';
import { IAuthClient } from './auth-client';
import { eventHandler } from '../infrastructure';
import { IEventHandler } from '../infrastructure';

export const authService = (
  handler: IEventHandler = eventHandler(),
  client: IAuthClient = new AuthClient(),
  profileClientInstance: ProfileClient = profileClient()
) => {
  return new AuthService(handler, client, profileClientInstance);
};
